var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M483.883,92.438l-64.32-64.299C401.607,10.062,377.159-0.072,351.68,0H96C43.005,0.059,0.059,43.005,0,96v320   c0.059,52.995,43.005,95.941,96,96h320c52.995-0.059,95.941-43.005,96-96V160.32C512.073,134.845,501.948,110.4,483.883,92.438z    M448,416c0,17.673-14.327,32-32,32H96c-17.673,0-32-14.327-32-32V96c0-17.673,14.327-32,32-32h32   c0,47.128,38.205,85.333,85.333,85.333h64c46.29-0.092,84.065-37.072,85.141-83.349c4.44,1.55,8.478,4.071,11.819,7.381   l64.341,64.341c6.015,5.986,9.387,14.128,9.365,22.613V416z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 256,
    cy: 298.667,
    r: 85.333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisk);
export default __webpack_public_path__ + "static/media/disk.01ff393cd313dc7340249293792bea6c.svg";
export { ForwardRef as ReactComponent };